
























































































































































































































































































































































import { Component } from "vue-property-decorator";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { i18n } from "@/resources/locales";
import moment from "moment";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { LANGUAGES } from "@/resources/constants/userLanguages";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "user-info-component",
})
export default class UserInfoComponent extends mixins(
  UserValidator,
  NotificationEvent,
  Plans
) {
  LANGUAGES = LANGUAGES;
  PLAN = PLAN;
  spaceUser;
  userTechnicalInfo: any;
  loading = true;
  loadingSendEmail = false;
  languages = [];
  experienceTag = [];
  learningTag = [];
  projectParticipationTag = [];
  destroyed(): void {
    this.showUserTechnicalInfo = false;
  }
  get active(): boolean {
    return this.$store.getters["SystemStore/getOpenUserInfoModal"];
  }
  set active(e: boolean) {
    this.$store.dispatch("SystemStore/setOpenUserInfoModalAction", e);
  }
  get showUserTechnicalInfo(): boolean {
    return this.$store.getters["SystemStore/getShowUserTechnicalInfo"];
  }
  set showUserTechnicalInfo(e: boolean) {
    this.$store.dispatch("SystemStore/setShowUserTechnicalInfoAction", e);
  }
  localUserIsNubiiAdmin(): boolean {
    return this.$store.getters["UserStore/getSpaceUser"].superSpaceUser.user
      .isNubiiAdmin;
  }
  get techicalInfo(): any {
    return this.$store.getters["SystemStore/getSpaceUserTechnicalInfoReceived"]
      .technicalInfo;
  }

  mounted(): void {
    this.$store.dispatch("UserStore/getUserInfoSuperSpaceAction", {
      superSpaceUserId: this.$store.getters["SystemStore/getUserInfoId"],
      callback: (data) => {
        this.loading = false;
        this.spaceUser = data.user;
        this.languages = this.spaceUser.languages || [];
        this.experienceTag = this.spaceUser.experienceTag || [];
        this.learningTag = this.spaceUser.learningTag || [];
        this.projectParticipationTag =
          this.spaceUser.projectParticipationTag || [];
      },
    });
  }
  getTimeZone(time: string): string {
    //const timeZoneList = i18n.locale === "en" ? TIME_ZONE_EN : TIME_ZONE_ES;
    //const timeZone = timeZoneList.filter((a) => a.timezone === time)[0];
    //const city = timeZone != undefined ? timeZone.name.substring(4, 10) : "";
    const d = new Date();
    const utc = d.getTime() + moment.tz(time).utcOffset() * 60000;
    const UTCOffsetInMilliseconds = new Date().getTimezoneOffset() * 60000;
    const calculatedTime = new Date(utc + UTCOffsetInMilliseconds);
    return (
      calculatedTime.getHours().toString().padStart(2, "0") +
      ":" +
      calculatedTime.getMinutes().toString().padStart(2, "0")
    );
  }
  getVacationDate(): string {
    if (this.spaceUser.vacationsEnd) {
      return moment(this.spaceUser.vacationsEnd).format(
        i18n.locale === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
      );
    }
    return "";
  }
  toggleTechnicalInfo(): void {
    this.showUserTechnicalInfo = !this.showUserTechnicalInfo;
    const container = document.getElementById("technical-info-container");
    if (this.showUserTechnicalInfo) {
      this.$store.dispatch(
        "SystemStore/setSpaceUserTechnicalInfoReceivedAction",
        {}
      );
      this.$store.dispatch("UserStore/requestSpaceUserTechnicalInfoAction", {
        userId: this.spaceUser.id,
        spaceId: this.$store.getters["SpaceStore/getSpace"].id,
        callback: (data) => {
          container.style.height = "260px";
          // this.loading = true;
        },
        callbackError: (error) => {
          console.log(error);
        },
      });
    } else {
      container.style.height = "0px";
    }
  }
  showCopyButton(): void {
    const button = document.getElementById("copy-button");
    button.style.opacity = "1";
  }
  hideCopyButton(): void {
    const button = document.getElementById("copy-button");
    button.style.opacity = "0";
  }
  copyTechnicalInfo(): void {
    const p = document.getElementById("technical-info-paragraph");
    const range = document.createRange();
    range.selectNode(p);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }

  copyInfo() {
    if (!this.activeOptionPlan(PLAN.COPY_OR_SEND_BUSINESS_CARD)) return;
    const newClip =
      "nubii \n\n" +
      this.spaceUser.name +
      " " +
      (this.spaceUser.lastName ? this.spaceUser.lastName : "") +
      "\n" +
      (!this.spaceUser.isGuest ? this.spaceUser.email : "") +
      "\n" +
      this.spaceUser.city +
      " " +
      this.getTimeZone(this.spaceUser.timezone) +
      "\n" +
      (this.spaceUser.vacationsEnd
        ? this.$i18n.t("labels.comingBack") +
          " " +
          this.getVacationDate() +
          "\n"
        : "") +
      this.spaceUser.occupation +
      "\n" +
      this.spaceUser.biography +
      "\n" +
      (this.spaceUser.myMotto ? this.spaceUser.myMotto + "\n" : "") +
      (this.spaceUser.linkedin && this.spaceUser.linkedin !== ""
        ? "linkedin: " + this.spaceUser.linkedin + "\n"
        : "") +
      (this.spaceUser.twitter && this.spaceUser.twitter !== ""
        ? "twitter: " + this.spaceUser.twitter + "\n"
        : "") +
      (this.spaceUser.socialEmail && this.spaceUser.socialEmail !== ""
        ? "twitter: " + this.spaceUser.socialEmail + "\n"
        : "");
    navigator.clipboard.writeText(newClip).then(
      () => {
        /* clipboard successfully set */
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.copyUrl")
        );
      },
      function () {
        /* clipboard write failed */
      }
    );
  }
  toMomentFormant(version) {
    return moment(parseInt(version)).utc().format("DDMMYY.HHmm");
  }
  sendInfoEmail() {
    if (!this.activeOptionPlan(PLAN.COPY_OR_SEND_BUSINESS_CARD)) return;
    this.loadingSendEmail = true;
    const space = this.$store.getters["SpaceStore/getSpace"] as SpaceInterface;
    if (!space) return;
    this.$store.dispatch("SpaceStore/sendInfoUserAction", {
      spaceId: space.id,
      userId: this.spaceUser.id,
      callback: () => {
        this.loadingSendEmail = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.sendInfoEmail")
        );
      },
      callbackError: () => {
        this.loadingSendEmail = false;
        this.onError(
          i18n.t("notifications.titles.error"),
          i18n.t("notifications.genericError.genericErrorRetry")
        );
      },
    });
  }
}
